import React, {Component} from 'react';

export default class ApplicantSubmitted extends Component {
    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);
    }

    render() {
        let applicant = JSON.parse(window.localStorage.getItem('BaseIndividualApplication'));
        return(
            <div>
                <question-row class="header-row">
                    <h1>Applicant Submitted</h1>
                </question-row>
                <question-row class="header-row">
                    <p>{applicant.firstName} {applicant.lastName} has been emailed the application link for them to complete.</p>
                </question-row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/ApplicantSubmitted.js